import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {BrowserRouter, Router} from 'react-router-dom';
import {createBrowserHistory} from 'history';
import {ResponsiveProvider} from '@/contexts/ResponsiveContext';
import {AppContextProvider} from '@/contexts/AppContext';
import {ThemeProvider} from '@/contexts/ThemeContext';

const history = createBrowserHistory();

const MainProvider = ({children}) => {

  return (
    <Router history={history}>
      <BrowserRouter>
        <ResponsiveProvider>
          <AppContextProvider>
            <ThemeProvider>
              {children}
            </ThemeProvider>
          </AppContextProvider>
        </ResponsiveProvider>
      </BrowserRouter>
    </Router>
  );
};

MainProvider.propTypes = {
  children: PropTypes.any,
  isMobile: PropTypes.bool
};

export default memo(MainProvider);
